import { useIdentity } from "context/auth";
import useAccountSummary from "hooks/useAccountSummary";
import { FC } from "react";
import { centsToDollars, valueOrUnknown } from "util/helpers";
import { Box, VStack } from "@chakra-ui/react";
import { Skeleton } from "antd";

const MoneyOnTheWay: FC = () => {
    const { accounts } = useIdentity();
    const { isLoading, data } = useAccountSummary(accounts[0]);
    const moneyOnTheWay = valueOrUnknown(
        data?.moneyOnTheWayInCents,
        centsToDollars,
    );

    return (
        <>
            <Box fontSize={18} fontWeight="semibold" color="white">
                {" "}
            </Box>
            <VStack justifyContent="center" alignItems="center" spacing={0}>
                <Box color="#9ca3af" fontWeight="semibold" fontSize={18}>
                    Money on the way
                </Box>
                <Box fontSize="6cqw">
                    {isLoading ? <Skeleton.Input active /> : moneyOnTheWay}
                </Box>
            </VStack>
            <Box justifyContent="right" display="flex" width="100%">
                <Box
                    as="button"
                    backgroundColor="darkGray"
                    px={2}
                    py={1}
                    borderRadius="md"
                >
                    See cards awaiting payment
                </Box>
            </Box>
        </>
    );
};

export default MoneyOnTheWay;
